import request from '@/utils/request'
import store from '@/store'

const url1 = 'elevatorProject'
const url2 = 'pm/project'

/** 获取所属项目列表 */
export function searchElevatorProjectList(data) {
  return request({
    url: `${url1}/searchElevatorProjectList`,
    method: 'post',
    data
  })
}

export function searchElevatorProjectListPm(data) {
  return request({
    url: `${url2}/searchElevatorProjectList`,
    method: 'post',
    data
  })
}

/** 获取所属项目下拉框 */
export function searchElevatorProjectSelectList() {
   return store.dispatch('searchElevatorProjectSelectList')
}

/** 查看项目 */
export function getElevatorProjectInfo(data) {
  return request({
    url: `${url1}/getElevatorProjectInfo`,
    method: 'post',
    data
  })
}

/** 修改项目 */
export function editElevatorProjectInfo(data) {
  return request({
    url: `${url1}/editElevatorProjectInfo`,
    method: 'post',
    data
  })
}

/** 删除项目 */
export function deleteElevatorProjectInfo(data) {
  return request({
    url: `${url1}/deleteElevatorProjectInfo`,
    method: 'post',
    data
  })
}

/** 添加项目 */
export function insertElevatorProject(data) {
  return request({
    url: `${url1}/insertElevatorProject`,
    method: 'post',
    data
  })
}

/** 添加项目 */
export function searchUserElevators(data) {
  return request({
    url: `elevator/searchUserElevators/${data}`,
    method: 'post',
  })
}


/** 获取授权的下拉项目列表 */
export function reqElevatorProjectSelectList(params) {
  return request({
    url: `${url1}/searchUserElevatorProjects`,
    method: "post"
  });
}

